function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9 22H7.2c-1.12 0-1.68 0-2.108-.218a2 2 0 01-.874-.874C4 20.48 4 19.92 4 18.8v-1.149c0-.978 0-1.468-.11-1.928a4 4 0 00-.48-1.156c-.247-.404-.593-.75-1.284-1.441L1 12l1.126-1.126c.691-.691 1.037-1.037 1.285-1.44a4 4 0 00.479-1.157c.11-.46.11-.95.11-1.928V5.2c0-1.12 0-1.68.218-2.108a2 2 0 01.874-.874C5.52 2 6.08 2 7.2 2H9m6 0h1.8c1.12 0 1.68 0 2.108.218a2 2 0 01.874.874C20 3.52 20 4.08 20 5.2v1.149c0 .978 0 1.468.11 1.928a4 4 0 00.48 1.156c.247.404.593.75 1.285 1.441L23 12l-1.125 1.126c-.692.691-1.038 1.037-1.285 1.44a4 4 0 00-.48 1.157c-.11.46-.11.95-.11 1.928V18.8c0 1.12 0 1.68-.218 2.108a2 2 0 01-.874.874C18.48 22 17.92 22 16.8 22H15M12.5 7a.5.5 0 01-1 0m1 0a.5.5 0 00-1 0m1 0h-1m1 5a.5.5 0 01-1 0m1 0a.5.5 0 00-1 0m1 0h-1m1 5a.5.5 0 01-1 0m1 0a.5.5 0 00-1 0m1 0h-1",
  fill: "none",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgBrackets = function SvgBrackets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    stroke: "#D6D7E1"
  }, props), _ref);
};

export default SvgBrackets;